import type { i18n as I18nInstance } from "i18next";

import type { I18nKey } from "~/i18n";
import { type ChildTaskStatus, type WorkLogEntry } from "../../session-logic";

export type TaskDisplayStatus = ChildTaskStatus | NonNullable<WorkLogEntry["taskStatus"]>;

const TASK_STATUS_LABELS: Record<TaskDisplayStatus, I18nKey> = {
  running: "chat/running_pifxwe",
  working: "chat/working_r0xt6p",
  finished: "chat/finished_9nf32d",
  failed: "chat/failed_t5mc04",
  stopped: "chat/stopped_qqfy90",
};

export function taskStatusLabel(i18n: I18nInstance, status: TaskDisplayStatus): string {
  return i18n.t(TASK_STATUS_LABELS[status]);
}
